var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1722_51571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.50024H2.5",
    stroke: "#CC293F",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5V10.5",
    stroke: "#CC293F",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.5V10.5",
    stroke: "#CC293F",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.50024V13.0002C12.5 13.1329 12.4473 13.26 12.3536 13.3538C12.2598 13.4476 12.1326 13.5002 12 13.5002H4C3.86739 13.5002 3.74021 13.4476 3.64645 13.3538C3.55268 13.26 3.5 13.1329 3.5 13.0002V3.50024",
    stroke: "#CC293F",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.49976V2.49976C10.5 2.23454 10.3946 1.98019 10.2071 1.79265C10.0196 1.60511 9.76522 1.49976 9.5 1.49976H6.5C6.23478 1.49976 5.98043 1.60511 5.79289 1.79265C5.60536 1.98019 5.5 2.23454 5.5 2.49976V3.49976",
    stroke: "#CC293F",
    strokeWidth: 1.50026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1722_51571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.e652d71fb3f79b0a6a0e99cbd92e8576.svg";
export { ForwardRef as ReactComponent };